// test2078
(2078 && 0);
